import { pathTrans } from './pathTrans';

export const classroomClassPath = pathTrans<{ classUid: string }>('classroom_class');
export const classroomClassAbsolutePath = pathTrans<{ classUid: string }>('classroom_class', {
    absolute: true,
});

/**
 * Review page contains TypeForm embed which does not return Cross-Origin-Resource-Policy header to fullfil COEP header
 * Thus to navigate from pages with COEP ("Cross-Origin-Embedder-Policy: require-corp") to review page,
 * you must use classroomClassReviewAbsolutePath instead of relative classroomClassReviewPath to enforce page reload (so no COEP header is set)
 * Note:
 * COEP header have to be set for zoom sdk, and must not be set for TypeForm (conflicting requirements)
 * Fortunately we uses zoom sdk and TypeForm on different pages,
 * so we can use conditional routing (on BE) to set COEP header based on the path (/review - no COEP header, all other paths - COEP header)
 * */
export const classroomClassReviewPath = pathTrans<
    { classUid: string } & ClassroomClassEndedPathQueryParams
>('classroom_class_review');
export const classroomClassReviewAbsolutePath = pathTrans<
    { classUid: string } & ClassroomClassEndedPathQueryParams
>('classroom_class_review', { absolute: true });
export const classroomClassLeaveClassPath = pathTrans<
    { classUid: string } & ClassroomClassEndedPathQueryParams
>('classroom_class_leave');

export const classroomDemoClassEntryPath = pathTrans('classroom_demo_class_entry');
export const classroomDemoClassPath = pathTrans<{ classUid: string }>('classroom_demo_class');
export const classroomDemoClassCompletedPath = pathTrans<{ classUid: string }>(
    'classroom_demo_class_completed',
);

export const classroomDiagnosticsPath = pathTrans('classroom_diagnostics');

export const studentAppHomeAbsolutePath = pathTrans('studentApp_home', { absolute: true });

export const studentClassDetailsAbsolutePath = pathTrans<{ classUid: string }>(
    'studentApp_class_details',
    { absolute: true },
);

export const teacherClassAbsolutePath = pathTrans<{ classUid: string }>(
    'teacherApp_class_details',
    {
        absolute: true,
    },
);

export const teacherAppHomeAbsolutePath = pathTrans('teacherApp_home', { absolute: true });

export interface ClassroomClassEndedPathQueryParams {
    duplicated?: boolean;
    endedByHost?: boolean;
    removedByTeacher?: boolean;
}
